import { NavLink } from "react-router-dom";
import { IconHeartFilled, IconHome, IconImport, IconLibrary, IconSearch } from "@/components/ui/icons";

const items = [
  { to: "/", icon: <IconHome />, label: "Accueil" },
  { to: "/search", icon: <IconSearch />, label: "Chercher" },
  { to: "/library", icon: <IconLibrary />, label: "Vous" },
  { to: "/liked", icon: <IconHeartFilled />, label: "Likés" },
  { to: "/import", icon: <IconImport />, label: "Import" },
];

export function BottomNav() {
  return (
    <nav className="bottomnav" role="navigation" aria-label="Navigation">
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          end={it.to === "/"}
          data-sfx="tap"
          className={({ isActive }) => "bottomnav-item" + (isActive ? " active" : "")}
        >
          <span className="bottomnav-icon">{it.icon}</span>
          <span className="bottomnav-label">{it.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
